module.exports = __webpack_public_path__ + "img/banner-mobile.89fbc152.png";